import React from 'react'
import ToolManagmentCard from '../../../../../../../common/element/Card/ToolManagmnetCard'

const CoachInfo = ({ companyData }) => {
  const coaches = companyData?.coaches || [];

  return (
    <ToolManagmentCard>
      <div>
        <h3 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828] mb-4 text-start">
          Coach Information
        </h3>

        {/* Scrollable area (show one coach only) */}
        <div className="max-h-[140px] overflow-y-auto pr-2 custom-scrollbar">
          {coaches.length === 0 ? (
            <p className="text-[#98A2B3] text-sm">No coaches assigned</p>
          ) : (
            coaches.map((coach, index) => (
              <div
                key={coach.coach_id || index}
                className="grid grid-cols-2 gap-y-4 border-t border-gray-200 pt-4 pb-4 text-start"
              >
                <div>
                  <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                    Coach Name
                  </label>
                  <p className="font-lato font-medium text-[16px] text-[#101828]">
                    {`${coach.first_name || ""} ${coach.last_name || ""}`}
                  </p>
                </div>

                <div>
                  <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                    Coach Email
                  </label>
                  <p className="font-lato font-medium text-[16px] text-[#101828]">
                    {coach.email || ""}
                  </p>
                </div>

                <div>
                  <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                    Coach Number
                  </label>
                  <p className="font-lato font-medium text-[16px] text-[#101828]">
                    {coach.work_phone ||coach.phone_landline || "" }
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </ToolManagmentCard>
  );
};

export default CoachInfo;
